module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_vm._v("The play was produced by the Royal Shakespeare Company, Stratford-upon-Avon, at The Other Place, 2 July 1992, with the following cast:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODYSSEUS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Ron Cook")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PENELOPE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Amanda Harris")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TELEMACHUS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Stephen Casey")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EURYCLEIA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Claire Benedict")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EUMAEUS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Trevor Martin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ATHENA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Susan-Jane Tanner")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BILLY BLUE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Rudolph Walker")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTINOUS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Jonathan Cake")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NESTOR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("David Westhead")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("THERSITES")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Gordon Case")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROTEUS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Antony Bunsee")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NAUSICAA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Sophie Okonedo")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CYCLOPS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Geoffrey Freshwater")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CIRCE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Bella Enahoro")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANTICLEA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Darlene Johnson")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ACHILLES")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Peter de Jersey")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "stnis"
  }, [_vm._v("Other parts played by members of the cast.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Director")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Gregory Doran")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Designer")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Michael Pavelka")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 75
// module chunks = 0